import { Link } from 'react-router-dom';
import './advisor.css';

export function NotFoundScreen() {
  return (
    <div className="authSplash">
      <p className="la-label">Nothing here</p>
      <h1 className="auth__title">That page does not exist</h1>
      <div className="la-cta-wrap">
        <Link to="/" className="la-btn-primary">
          Back to your book
        </Link>
      </div>
    </div>
  );
}
